import { FontFamily } from './fontFamily/fontFamily';
import { allAvailableFonts } from '@/data/items';
import { DebugHelper } from '@/helper/debugHelper';

export default { getAvailableFonts }

// Electron以外では単に空のDBを扱う
function getAvailableFonts(): Promise<FontFamily[]> {
    return new Promise(resolve => {
        var isCompleted = false;
        const timeout = setInterval(() => {
            if (!localStorage.getItem("local-font") || localStorage.getItem("local-font-ready")) {
                clearInterval(timeout);
                isCompleted = true;
                allAvailableFonts().then(resolve);
                DebugHelper.trace("Local fonts are loaded completely.");
            }
        }, 20);
        setTimeout(() => {
            if(isCompleted) return;
            // 20秒待ってもダメならタイムアウトする
            DebugHelper.trace("ローカルフォントの読み込みがタイムアウトしました。");
            clearInterval(timeout);
            resolve([]);
        }, 20000);
    })
}
